import type { Session as AnalyticsSession } from "@threekit/analytics";
import {
  buildOptionsShowForAttribute,
  getConfiguratorAttributeList,
  isRecord,
} from "./configurator-attribute-utils";

type OptionsShowParams = Parameters<AnalyticsSession["optionsShow"]>[0];

export interface OptionsShowAllFromConfiguratorOptions {
  /**
   * Catalog item id for buyer analytics (recommended).
   * https://developer.threekit.com/reference/analytics-sdk#options-show
   */
  parentAssetId?: string;
  /**
   * Use `getDisplayAttributes({ includeHidden: true })` instead of `getAttributes()`.
   * https://developer.threekit.com/reference/configurator-api#get-display-attributes
   */
  useDisplayAttributes?: boolean;
}

export interface OptionsShowAllConfiguratorHandle {
  /** Classic player configurator (getAttributes / getDisplayAttributes). */
  configurator: unknown;
  optionsShow: (params: OptionsShowParams) => void;
  /** Set by embed init when `assetId` was provided */
  productAssetId?: string;
}

/**
 * Reads attributes (and their option lists) from the Configurator API, then fires
 * `optionsShow` once per attribute. See
 * https://developer.threekit.com/reference/configurator-api
 */
export function optionsShowAllFromConfigurator(
  handle: OptionsShowAllConfiguratorHandle,
  opts: OptionsShowAllFromConfiguratorOptions = {}
): void {
  const useDisplay = opts.useDisplayAttributes === true;
  const attrs = getConfiguratorAttributeList(handle.configurator, useDisplay);

  const parentAssetId = opts.parentAssetId ?? handle.productAssetId;

  for (const attr of attrs) {
    if (!isRecord(attr)) continue;
    const params = buildOptionsShowForAttribute(attr, parentAssetId);
    if (params) handle.optionsShow(params);
  }
}
